import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

export const useDeleteCustomerBoSubscription = (
  customerId: number,
  subscriptionId: number
) => {
  const queryClient = useQueryClient();

  const deleteCustomerSubscription = async () => {
    await Axios.delete(
      `${DELETE_URL(customerId.toString(), subscriptionId.toString()).deleteCustomerSubscription}`
    );
  };

  return useMutation<void, AxiosError<BaseError>>(deleteCustomerSubscription, {
    onSuccess: () => {
      queryClient.invalidateQueries(['customerSubscriptions', customerId]);
      queryClient.invalidateQueries([
        'customerSubscription',
        customerId,
        subscriptionId
      ]);
    },
    useErrorBoundary: false
  });
};
